import { configureStore } from '@reduxjs/toolkit'
import authReducer from './auth/authSlice'
import authMiddlewares from './auth/authMiddlewares'

const store = configureStore({
  reducer: {
    authReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(authMiddlewares),
})

export default store
